import type {Field} from "../../../../../data/models/field/Field";
import {FieldDataType} from "../../../../../generated/api/base";
import ToggleIcon from "../../../icons/toggle.svg?react";
import DateTimeIcon from "../../../icons/date-time.svg?react";
import EmailIcon from "../../../icons/mail.svg?react";
import LocationIcon from "../../../icons/map-pin-alt.svg?react";
import IPIcon from "../../../icons/network-wired.svg?react";
import MultiSelectIcon from "../../../icons/list-check.svg?react";
import NumberIcon from "../../../icons/hashtag.svg?react";
import PhoneIcon from "../../../icons/phone.svg?react";
import SingleSelectIcon from "../../../icons/singleselect.svg?react";
import MultiLineIcon from "../../../icons/menu-alt-1.svg?react";
import SingleLineIcon from "../../../icons/text.svg?react";
import UserIcon from "../../../icons/user.svg?react";
import UsersIcon from "../../../icons/users.svg?react";
import TypeIcon from "../../../icons/shapes.svg?react";
import SystemIcon from "../../../icons/gear.svg?react";
import ModelIcon from "../../../icons/cube-alt-1.svg?react";

export const getFieldTypeIcons = (field: Field) => {
	switch (field.dataType) {
		case FieldDataType.Boolean:
			return <ToggleIcon />;
		case FieldDataType.DateTime:
			return <DateTimeIcon style={{transform: "translateX(2px)"}} />;
		case FieldDataType.Email:
			return <EmailIcon />;
		case FieldDataType.GeoLocation:
			return <LocationIcon />;
		case FieldDataType.IPAddress:
			return <IPIcon />;
		case FieldDataType.MultipleChoiceList:
			return <MultiSelectIcon />;
		case FieldDataType.Numeric:
			return <NumberIcon />;
		case FieldDataType.PhoneNumber:
			return <PhoneIcon />;
		case FieldDataType.SingleChoiceList:
			return <SingleSelectIcon />;
		case FieldDataType.MultiLineText:
			return <MultiLineIcon />;
		case FieldDataType.SingleLineText:
			return <SingleLineIcon />;
		case FieldDataType.User:
			return <UserIcon />;
		case FieldDataType.Type:
			return <TypeIcon />;
		case FieldDataType.Model:
			return <ModelIcon />;
		case FieldDataType.SystemFields:
			return <SystemIcon />;
		case FieldDataType.PeopleSingleChoiceList:
			return <UserIcon />;
		case FieldDataType.PeopleMultipleChoiceList:
			return <UsersIcon />;
		default:
			return <div style={{width: "24px", height: "24px"}}></div>;
	}
};
